import PropTypes from "prop-types"
import classnames from "classnames"
import StatCard from "./stat_card"
import LineComparisonChart from "./charts/line_comparison_chart"
import Tooltip from "./tooltip"

export default function SimpleLineChart(props) {
  return (
    <div
      className={classnames("premium-chart-container", {
        wide: props.wide,
      })}
    >
      <div className="chart-header">
        <StatCard
          stat={props.currentValue}
          changeRate={props.changeRate}
          statText={props.chartTitle}
          className="chart-data"
          timePeriodInDays={props.timePeriodInDays}
          precision={props.precision}
          isPercentage={props.isPercentage}
          lowerIsBetter={props.lowerIsBetter}
          compactThreshold={99999}
        />
        <div className="chart-legend">
          <div className="tooltip">
            <Tooltip content={props.tooltipText} />
          </div>
          <div className="items">
            <div className="legend">
              <div
                className="line-color"
                style={{ backgroundColor: props.lineColorA }}
              />
              <span>Last {props.timePeriodInDays} days</span>
            </div>
            <div className="legend">
              <div
                className="line-color"
                style={{ backgroundColor: props.lineColorB }}
              />
              <span>Prior {props.timePeriodInDays} days</span>
            </div>
          </div>
        </div>
      </div>
      <LineComparisonChart
        data={props.data}
        metric={props.metric}
        timePeriodInDays={props.timePeriodInDays}
        lineOnly={props.lineOnly}
        units={props.units}
      />
    </div>
  )
}

SimpleLineChart.propTypes = {
  chartTitle: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  currentValue: PropTypes.number.isRequired,
  changeRate: PropTypes.number.isRequired,
  metric: PropTypes.string.isRequired,
  units: PropTypes.string.isRequired,
  lineColorA: PropTypes.string,
  lineColorB: PropTypes.string,
  timePeriodInDays: PropTypes.number,
  lineOnly: PropTypes.bool,
  tooltipText: PropTypes.string,
  wide: PropTypes.bool,
  precision: PropTypes.number,
  isPercentage: PropTypes.bool,
  lowerIsBetter: PropTypes.bool,
}

SimpleLineChart.defaultProps = {
  lineColorA: LineComparisonChart.defaultProps.lineColorA,
  lineColorB: LineComparisonChart.defaultProps.lineColorB,
  timePeriodInDays: LineComparisonChart.defaultProps.timePeriodInDays,
}
